import React, { useState, useEffect } from 'react';
import {connect} from "react-redux";
import {browserHistory} from "react-router";
import _ from 'i18n';
import {createCardRegistration, getToken, cardWebPayin, mangoPayCallback} from 'thunks';
import {Input, Button, notification, Row, Col} from 'antd';
import IBAN from 'iban';
import {PSPID, OGONE_URL, TTP_PAYMENT_URL} from 'Config';
import { TTP_API_URL, client_id, server_url } from 'Config';
import mangoPay from 'mangopay-cardregistration-js-kit';
import {showSpinner} from "../../../actions/actions/mangoPay";
import valid from 'card-validator'
import moment from "moment/moment";
import {expirationDate} from "card-validator/dist/expiration-date";
import { Radio } from 'antd';
import { Checkbox } from 'antd';
import {
  cardRegistrationForOrganization,
  FeedMangoWalletForOrganizationPayIn, mangoPayCallbackForOrganization
} from "../../../actions/thunks/mangoPay";
import { set } from 'lodash';



const ibantools = require('ibantools');


const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
    description,
    style: {
      marginTop: 120,
    },
  });
};


const type = {
  v4: {
    httpsUrl: "https://api.ipify.org/"
  },
  v6: {
    httpsUrl: "https://api6.ipify.org/"
  }
};

const CardRegistration = ({
  orderId,
  amount,
  isCreditNote,
  creditNoteId,
  isRefund,
  redirectionURL,
  currentClient,
  user,
  isCommunity,
  showSpinner,
  FeedMangoWalletForOrganizationPayIn,
  cardRegistrationForOrganization,
  mangoPayCallbackForOrganization
}) => {

const [CardNumber, setCardNumber] = useState("");
const [dateExpiration, setDateExpiration] = useState("");
const [CVC, setCVC] = useState("");
const [isCardNumberValid, setIsCardNumberValid] = useState(true);
const [isDateExpirationValid, setIsDateExpirationValid] = useState(true);
const [isCvvValid, setIsCvvValid] = useState(true);
const [userCardType, setUserCardType] = useState("");
const [value, setValue] = useState("CB_VISA_MASTERCARD");
const [checkedRegistrCard, setCheckedRegistrCard] = useState(true);
const [pathImageLogo, setPathImageLogo] = useState("");
const [ipAdress, setIpAdress] = useState("");
const [tryCount, setTryCount] = useState(5);

    // this.originalState = {
    //   originalBic : " ",
    //   originalIban : " ",
    // };

  useEffect(() => {
    const loadIp = async () => {
      const ip = await getIp("v4") || JSON.parse(await getIpJsonTest())['ip'];
      setIpAdress(ip);
    };

    loadIp();
  }, []);

  const getIp = async (version) => {
    const data = type[version];
    try {
      const response = await fetch(data.httpsUrl);
      return await response.text(); // ajout await pour attendre la réponse du fetch avant de continuer
    } catch (e) {
      if(tryCount > 0) {
        setTryCount(prev => prev - 1);
        return await getIp(version)
      }
      return null;
    }
  };

  const getIpJsonTest = async () => {
    try {
      const response = await fetch("http://ip.jsontest.com/");
      return await response.text();
    } catch (e) {
      return null;
    }
  };

  const handleCardNumberInputChange = (value) => {
    setCardNumber(value.trim());
    var numberValidation = valid.number(value);
    if (numberValidation.card) {
      setIsCardNumberValid(true);
      setUserCardType(numberValidation.card.type);
      if(numberValidation.card.type == "visa") {
        setPathImageLogo("/img/icons/visa.svg");
      }

      else if (numberValidation.card.type == "mastercard") {
        setPathImageLogo("/img/icons/mastercard (1).svg");
      }

      else if (numberValidation.card.type == "maestro") {
        setPathImageLogo("/img/icons/maestro (2).svg");
      } else {
        setPathImageLogo("");
      }
    } else {
      setPathImageLogo("");
    }
  }

  const handleCSVInputChange = (v) => {
    setCVC(v.trim());

    let cvvValidation = valid.cvv(v);

    if(cvvValidation.isValid)
    {
      setIsCvvValid(true);
    }

  }

  const handleDateExpirationInputChange = (value) => {
    let regex = /[0-9][0-9]/g;
    let found = value.match(regex);

    let newValue = value;

    if(found && value.length == 2) {
      // newValue = value+"/"
    }

    if(value.length > 2 && value.substr(2, 1) !== "/") {
      newValue = value.substr(0, 2)+"/"+value.substr(2)
    }

    setDateExpiration(newValue.trim());

    var dateExpirationValidation = valid.expirationDate(newValue);

    if (dateExpirationValidation.isValid) {
      setIsDateExpirationValid(true);
    }
  }

  const onBlurInput = () =>{

    var dateExpirationValidation = valid.expirationDate(dateExpiration);

    if(dateExpiration.length < 5) {
      setIsDateExpirationValid(false);

    } else {
      if (!dateExpirationValidation.isPotentiallyValid) {
        setIsDateExpirationValid(false);
      }

      if (dateExpirationValidation.isValid) {
        setIsDateExpirationValid(true);
      }
    }
  }

  const onBlurCardNumberInputInput = () => {
    var numberValidation = valid.number(CardNumber);

    if (!numberValidation.isPotentiallyValid) {
      setIsCardNumberValid(false);
    }

    if (numberValidation.card) {
      setIsCardNumberValid(true);
      setUserCardType(numberValidation.card.type);
    }
  }

  const onBlurCVVInput =() => {
    let cvvValidation = valid.cvv(CVC);

    if (!cvvValidation.isPotentiallyValid) {

      setIsCvvValid(false);
    }

    if(cvvValidation.isValid)
    {
      setIsCvvValid(true);
    }

  }
  const postToken = () => {
    setShowSpinner(true);

    let expirationDate = "";

    let cardType = userCardType;


    if(userCardType == "maestro") {
      // on va griser l input de cvv
      cardType = "BCMC"
    } else {cardType = "CB_VISA_MASTERCARD"}

    cardRegistrationForOrganization(currentClient.id, cardType).then(res => {
      if(res.value.status == 200) {
        if(dateExpiration.length > 5) {
          expirationDate = moment(dateExpiration, 'MM/YYYY').format('MMYY')
        } else {
          expirationDate = moment(dateExpiration, 'MM/YY').format('MMYY')
        }
        // Set MANGOPAY API base URL and Client ID
        mangoPay.cardRegistration.baseURL = server_url;
        mangoPay.cardRegistration.clientId = client_id;

        mangoPay.cardRegistration.init({
          cardRegistrationURL: res.value.data.data[0].CardRegistrationURL,
          preregistrationData: res.value.data.data[0].PreregistrationData,
          accessKey: res.value.data.data[0].AccessKey,
          Id: res.value.data.data[0].Id
        });

        const cardData = {
          cardNumber : CardNumber,
          cardExpirationDate : expirationDate,
          cardCvx : CVC,
          cardType: cardType,
        };

        const params = {
          'adressIp' :  ipAdress,
          'javaEnabled' : window.navigator.javaEnabled(),
          'Language' : window.navigator.language,
          'userAgent' : window.navigator.userAgent,
          'timeZoneOffset' : new Date().getTimezoneOffset(),
          'colorDepth' : screen.colorDepth,
          'screenHeight' : screen.height,
          'screenWidth' : screen.width,

        }

        mangoPay.cardRegistration.registerCard(
          cardData,
          (res) => {
            FeedMangoWalletForOrganizationPayIn(orderId, amount,res.CardId, !checkedRegistrCard, params, isCreditNote, creditNoteId, isRefund, redirectionURL, currentClient.id, user.id).then(res => {
              if(res.data.data.result == "failed") {
                window.open(res.data.data.redirect_url, "_self")
                showSpinner(false)
              } else {
                if(res.data.data.secureMode == true) {
                  window.location.assign(res.data.data.redirect_url);
                } else {
                  // lancer le thunk pour le post paiement processing
                  mangoPayCallbackForOrganization(res.data.data.orderId, res.data.data.transaction_id, res.data.data.deleteCard, creditNoteId, isCreditNote, amount, isRefund, redirectionURL, user.id).then((res) => {
                    //ajouter unr notif si le peiement est ok avant de faire la redirection
                    if(res.data){
                      window.location.assign(res.data.redirectionUrl);
                    }
                  })
                }

              }
            })
          },
          (res) => {
            showSpinner(false)
            openNotificationWithIcon('error', _('incompleteOperation'), _('error'))
          }
        );

      }
    })


  };

  const onChangeRadio = e => {
    setValue(e.target.value);
  };

  const onchangeCheckbox = e => {
    setCheckedRegistrCard(e.target.checked);

  };

  const handleCancelClick = () => {
    setCardNumber("");
    setDateExpiration("");
    setCVC("");
    setIsCardNumberValid(true);
    setIsDateExpirationValid(true);
    setIsCvvValid(true);
    setUserCardType("");
    setValue("CB_VISA_MASTERCARD");
    setPathImageLogo("");
  };

    return (
      <div className={"card-registration-container " + (isCommunity ? 'community' : '')}>
        <div className={'card-registration-title mb-4 ' + (isCommunity ? 'community-theme' : '')}>{_("NEW_BANK_CARD") + ' :'}</div>
        <div className="payment-with-card mb-3">
          <label className="new-card-label">{_("card-Number")}<span className={isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
          <Input
            value={CardNumber}
            onChange={({ target: { value } }) => handleCardNumberInputChange(value)}
            className = {isCommunity ? 'new-community-input' : 'new-card-input'}
            suffix={
              <div>
                {pathImageLogo !== "" ? <img src={pathImageLogo} className={'card-img-suffix'} /> : null}
              </div>
            }
            onBlur={onBlurCardNumberInputInput}
          />
        </div>
        <Row>
          <Col span={12} className={'pr-2'}>
            <div className="payment-with-card">
              <label className="new-card-label">{_("expiration-Date")}<span className={isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
              <Input
                value={dateExpiration}
                onChange={({ target: { value } }) => handleDateExpirationInputChange(value)}
                className = {isCommunity ? 'community-input' : 'new-input'}
                onBlur={onBlurInput}
              />
            </div>
          </Col>
          <Col span={12} className={'pl-2'}>
            <div className="payment-with-card">
              <label className={"new-card-label"}>{_("CVV") }<span className={isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
              <Input
                value={CVC}
                onChange={({ target: { value } }) => handleCSVInputChange(value)}
                className = {isCommunity ? 'community-input' : 'new-input'}
                onBlur={onBlurCVVInput}
                disabled={userCardType == 'maestro'}
              />
            </div>
          </Col>
        </Row>
        <div className="mt-3 flex justify-end mb-4">
          <Checkbox checked={checkedRegistrCard} onChange={onchangeCheckbox}>{_("Enregistrer-et-payer-avec-une-autre-carte")}</Checkbox>
        </div>
        <Row>
          <Col span={12}>
            <button type="button" onClick={handleCancelClick} className={'new-card-cancel-button flex items-center ' + (CVC == "" && dateExpiration == "" && CardNumber == "" ? 'user-card-button-not-allowed' : '')} >{_('cancel')}</button>
          </Col>
          <Col span={12} className={'flex justify-end'}>
            <button type="button" onClick={postToken} className={'user-card-button card-registration flex items-center ' + (isCommunity ? 'community-theme ' : '') + (!isCvvValid || !isDateExpirationValid || !isCardNumberValid || (CVC == "" && userCardType !== 'maestro') || dateExpiration == "" || CardNumber == "" ? 'user-card-button-not-allowed ' : '')}>{_('USE_THIS_CARD')}</button>
          </Col>
        </Row>
      </div>
    )

}

const mapStateToProps = state => ({
  cardRegistration: state.cardRegistration,
  orderLines: state.orderLines,
  currentClient: state.auth.currentClient,
  user: state.auth.user,
});

const mapDispatchToProps = {
  createCardRegistration,
  getToken,
  cardWebPayin,
  showSpinner,
  mangoPayCallback,
  FeedMangoWalletForOrganizationPayIn,
  cardRegistrationForOrganization,
  mangoPayCallbackForOrganization,
};


export default connect(mapStateToProps, mapDispatchToProps)(CardRegistration);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/CardRegistration.js